(() => {
  // Güvenlik: hata olursa siteyi bozmasın
  try {
    const getLocale = () =>
      String(window.__STORE_LOCALE__ || document.documentElement.lang || 'en').toLowerCase();

    const isTR = () => getLocale().startsWith('tr');
    const isEN = () => getLocale().startsWith('en');

    const SEL_TITLE = '[data-essential-upsell-element="title"]';
    const SEL_BTN   = '[data-essential-upsell-element="add-to-cart-button"]';

    const apply = () => {
      const titleEl = document.querySelector(SEL_TITLE);
      const btnEl   = document.querySelector(SEL_BTN);

      // App daha gelmediyse çık
      if (!titleEl && !btnEl) return false;

      // TITLE (isteğe bağlı)
      if (titleEl) {
        titleEl.textContent = isTR() ? 'Stilini Tamamla!' : 'Complete the Look!';
      }

      // BUTTON:
      // - TR: hiç dokunma (app zaten "Kombini Ekle" veriyor)
      // - EN: eğer butonda "Kombini Ekle" yazısı varsa "Add the Set" yap (fiyatları bozmadan)
      if (btnEl && isEN()) {
        const firstText = Array.from(btnEl.childNodes).find(
          n => n.nodeType === Node.TEXT_NODE && n.textContent.trim().length
        );

        if (firstText) {
          // EN'de yanlışlıkla Kombini Ekle görünüyorsa düzelt
          firstText.textContent = firstText.textContent.replace('Kombini Ekle', 'Add the Set');
        }
      }

      return true;
    };

    // İlk denemeler (app geç yüklenebiliyor)
    let tries = 0;
    const t = setInterval(() => {
      tries++;
      const done = apply();
      if (done || tries > 20) clearInterval(t); // max ~10 sn
    }, 500);

    // Observer ama throttle’lu
    let scheduled = false;
    const obs = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      setTimeout(() => {
        scheduled = false;
        apply();
      }, 200);
    });
    obs.observe(document.body, { childList: true, subtree: true });

  } catch (e) {
    console.warn('[EU i18n] error', e);
  }
})();
